'use client';

import 'react';
import getElementClientRect from '../helpers/getElementClientRect.js';

function hide(_a) {
    var scrollableParents = _a.scrollableParents, reference = _a.reference, popupConfigs = _a.popupConfigs;
    var _b = (popupConfigs || {}).detectHidden, detectHidden = _b === void 0 ? false : _b;
    /*
     * Return immediately if not enable detect hidden
     * */
    if (!detectHidden) {
        return false;
    }
    var isHidden = false;
    /*
     * Reference values
     * */
    var referenceRect = reference.getBoundingClientRect();
    var referenceLeft = referenceRect.left;
    var referenceRight = referenceRect.right;
    var referenceTop = referenceRect.top;
    var referenceBottom = referenceRect.bottom;
    var scrollableParentsLength = scrollableParents.size;
    var arrayScrollableParents = Array.from(scrollableParents);
    for (var i = 0; i < scrollableParentsLength; ++i) {
        var parentRect = getElementClientRect(arrayScrollableParents[i]);
        var parentLeft = parentRect.left;
        var parentRight = parentRect.right;
        var parentTop = parentRect.top;
        var parentBottom = parentRect.bottom;
        isHidden =
            referenceRight < parentLeft ||
                referenceLeft > parentRight ||
                referenceBottom < parentTop ||
                referenceTop > parentBottom;
        if (isHidden) {
            break;
        }
    }
    return isHidden;
}

export { hide as default };
//# sourceMappingURL=hide.js.map
